<template>
  <PCSettingsBlock :title="t('userConfiguration.inventoryRegularization.title')">
    <PCSettingsBlockItem :title="t('userConfiguration.inventoryRegularization.type.title')">
      <template #right>
        <f7-button
          small
          popover-open=".popover-inventory-regularization"
          class="button-order-text"
        >
          {{ currentRegularizationText }}
        </f7-button>
      </template>
    </PCSettingsBlockItem>

    <f7-popover
      v-model:opened="isRegularizationTypePopoverOpened"
      class="popover-inventory-regularization"
    >
      <f7-list>
        <f7-list-item
          v-for="option in regularizationOptions"
          :key="option.value"
          :title="option.title"
          popover-close
          @click="countForm = /** @type {any} */ (option.value); isRegularizationTypePopoverOpened = false"
        />
      </f7-list>
    </f7-popover>
  </PCSettingsBlock>
</template>

<script setup>
// @ts-check
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useSettingRef } from '@erpagroapp/settings';

import PCSettingsBlock from './PCSettingsBlock.vue';
import PCSettingsBlockItem from './PCSettingsBlockItem.vue';

const { t } = useI18n();
const countForm = useSettingRef('InventarioRegularizacion.FormaRecuento');

function useRegularizationType() {
  const regularizationOptions = [
    { title: t('userConfiguration.inventoryRegularization.type.count'), value: 0 },
    { title: t('userConfiguration.inventoryRegularization.type.countAndRegularization'), value: 1 },
  ];

  const isRegularizationTypePopoverOpened = ref(false);

  const currentRegularizationText = computed(
    () => regularizationOptions.find(
      (x) => x.value === countForm.value,
    )?.title || '',
  );

  return {
    regularizationOptions,
    isRegularizationTypePopoverOpened,
    currentRegularizationText,
  };
}

const {
  regularizationOptions,
  isRegularizationTypePopoverOpened,
  currentRegularizationText,
} = useRegularizationType();
</script>

<style scoped lang="scss">
.button-order-text {
  --f7-button-small-text-transform: initial;
}
</style>
